var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#fafafa","padding":"16px"}},[(_vm.checkHtml(_vm.content) === false)?_c('vditor-preview',{attrs:{"content":_vm.content}}):_c('am-editor',{attrs:{"content":_vm.content,"model":"view","drag":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }